import { render, staticRenderFns } from "./register.vue?vue&type=template&id=61a7b5c2&scoped=true&"
import script from "./register.ts?vue&type=script&lang=ts&"
export * from "./register.ts?vue&type=script&lang=ts&"
import style0 from "./register.scss?vue&type=style&index=0&id=61a7b5c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a7b5c2",
  null
  
)

export default component.exports